import { render, staticRenderFns } from "./TabClose.vue?vue&type=template&id=22a3bb12"
import script from "./TabClose.vue?vue&type=script&lang=js"
export * from "./TabClose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports